import { render, staticRenderFns } from "./PoweredByApp8.vue?vue&type=template&id=7cf0fe1e"
import script from "./PoweredByApp8.vue?vue&type=script&lang=ts"
export * from "./PoweredByApp8.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports